module.exports = __webpack_public_path__ + "white_wall.png?6cb0935c4be70dfb097384f40827fb32";


//////////////////
// WEBPACK FOOTER
// ./assets/white_wall.png
// module id = 31
// module chunks = 0